import { OptionType, useFilterContext } from "../shared/context/FilterContext";

export const useDropdown = () => {

    const { options, loading, error } = useFilterContext();

    const getOptions = (type: OptionType) => options[type];

    const getDisplayText = (type: OptionType, id: string) => {
        const match = options[type].find(
            (value: { id: string }) => value.id === id
        );
        const matchValue = match?.contractor_display_name || match?.activity || match?.description || match?.authority_name || match?.display_name || match?.org_name;
        return match ? matchValue : id;
    };

    return {
        options,
        loading,
        error,
        getOptions,
        getDisplayText
    };

};